module.exports = __webpack_public_path__ + "static/media/item4.04064659.png";